module.exports = __webpack_public_path__ + "static/33-thumb-0b7a819156537356ab63f53c2d2b5f3a.jpg";